'use client';

import React, { useMemo, useState } from 'react';
import { useTranslations } from 'next-intl';
import { DoctorListInCard, SkillsSelect } from '@/widgets/DoctorListInCard';
import { MedcenterDoctors } from './MedcenterDoctors';
import type { IBaseDoctor } from '@/entities/doctor/model/types';
import type { Skill } from '@/entities/skill/model/types';
interface Props {
  skills: Skill[];
  doctors?: IBaseDoctor[];
  medcenterAlias: string;
}
export const OurDoctors: React.FC<Props> = ({
  skills,
  doctors = [],
  medcenterAlias
}) => {
  const t = useTranslations();
  const [selectedSkill, setSelectedSkill] = useState<Skill | null>(null);
  const changeSkill = (value: string) => {
    const id = Number(value);
    setSelectedSkill(skills.find(skill => skill.id === id) || null);
  };
  const skillsOptions = useMemo(() => {
    return skills.map(skill => ({
      value: skill.id,
      label: skill.name
    }));
  }, [skills]);
  return <DoctorListInCard title={t('medcenter.our_doctors.title')} sectionId="our-doctors" className="w-full rounded-2xl bg-bgPrimary p-4" data-sentry-element="DoctorListInCard" data-sentry-component="OurDoctors" data-sentry-source-file="OurDoctors.tsx">
      <div className="mt-4 w-full">
        <SkillsSelect placeholder={t('medcenter.our_doctors.skills_select_placeholder')} value={selectedSkill?.id ? selectedSkill.id.toString() : ''} changeValue={changeSkill} options={skillsOptions} data-sentry-element="SkillsSelect" data-sentry-source-file="OurDoctors.tsx" />
      </div>
      <div className="w-full space-y-4">
        <MedcenterDoctors initialDoctors={doctors} selectedSkill={selectedSkill} medcenterAlias={medcenterAlias} data-sentry-element="MedcenterDoctors" data-sentry-source-file="OurDoctors.tsx" />
      </div>
    </DoctorListInCard>;
};